import { INTERSECTION_TYPE, ACTIVATE_JOIN_LINE_TOOL, ACTIVATE_INTERSECTION_SPLIT_LINE_TOOL, SELECTED_SEGMENTS, UPDATE_JOIN_LINE_TOOL, DEACTIVATE_TOOL, UPDATE_SELECT_FEATURE_TOOL, UPDATE_LOADED_FEATURES, } from './constants';
const initialState = {
    loadedFeatures: [],
    intersectionInteraction: {
        isActive: false,
        supportedHighlightTypes: [],
        supportedEditTypes: [],
        selectedHighlightSegments: SELECTED_SEGMENTS.NONE,
        selectedEditSegments: SELECTED_SEGMENTS.NONE,
    },
    joinLineTool: {
        joinFeatures: [],
        editFeature: null,
        highlightFeature: null,
    },
    selectFeatureTool: {
        selectedFeature: null,
        selectedFeatureData: null,
    },
};
export const editTools = (state = initialState, action) => {
    switch (action.type) {
        case DEACTIVATE_TOOL: {
            return {
                ...state,
                intersectionInteraction: { ...initialState.intersectionInteraction },
            };
        }
        case ACTIVATE_INTERSECTION_SPLIT_LINE_TOOL: {
            return {
                ...state,
                intersectionInteraction: {
                    ...initialState.intersectionInteraction,
                    isActive: true,
                    supportedHighlightTypes: [INTERSECTION_TYPE.CROP],
                    supportedEditTypes: [INTERSECTION_TYPE.CROP],
                    selectedHighlightSegments: SELECTED_SEGMENTS.ALL,
                    selectedEditSegments: SELECTED_SEGMENTS.ALL,
                },
            };
        }
        case ACTIVATE_JOIN_LINE_TOOL: {
            return {
                ...state,
                intersectionInteraction: {
                    ...initialState.intersectionInteraction,
                    isActive: true,
                    supportedHighlightTypes: [
                        INTERSECTION_TYPE.EXTEND,
                        INTERSECTION_TYPE.CROP,
                        INTERSECTION_TYPE.REPLACE,
                    ],
                    supportedEditTypes: [INTERSECTION_TYPE.EXTEND, INTERSECTION_TYPE.CROP],
                    selectedHighlightSegments: SELECTED_SEGMENTS.ONE,
                    selectedEditSegments: SELECTED_SEGMENTS.OUTER,
                },
            };
        }
        case UPDATE_JOIN_LINE_TOOL: {
            return {
                ...state,
                joinLineTool: {
                    ...state.joinLineTool,
                    ...action.payload,
                },
            };
        }
        case UPDATE_LOADED_FEATURES: {
            return {
                ...state,
                loadedFeatures: action.payload,
            };
        }
        case UPDATE_SELECT_FEATURE_TOOL: {
            return {
                ...state,
                selectFeatureTool: {
                    ...state.selectFeatureTool,
                    ...action.payload,
                },
            };
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=reducer.js.map